export enum RecommendationsMessageEnum {
    MODAL,
    FLOATING
}
